export default defineNuxtPlugin((nuxtApp) => {
  // Solo en modo desarrollo
  if (process.env.NODE_ENV !== 'development') {
    return
  }

  const router = useRouter()
  let previousRoute: string | null = null

  router.afterEach((to, from) => {
    const fromPath = from.fullPath || '(inicio)'
    const toPath = to.fullPath

    // Evitar log en la primera carga
    if (previousRoute === null && from.fullPath === '/') {
      previousRoute = toPath
      return
    }

    // Estilos para consola con fondo azul
    const styles = [
      'background: #2563eb',
      'color: white',
      'padding: 4px 8px',
      'border-radius: 3px',
      'font-weight: bold'
    ].join(';')

    console.log(
      `%c 🧭 Navegación `,
      styles,
      `\n  Desde: ${fromPath}\n  Hacia: ${toPath}`
    )

    previousRoute = toPath
  })
})
